import React, { useContext } from 'react';
import classNames from 'classnames';
import { Button } from 'ncoded-component-library';
import { useTranslation } from 'react-i18next';
import XcircleIcon from 'icons/Xcircle.icon';
import DataRoomDocumentsContext from '../../providers/DataRoomDocuments/DataRoomDocuments.context';

import './DocumentsViewAsBanner.styles.scss';
import './DocumentsViewAsBanner.styles.responsive.scss';

const DocumentsViewAsBanner = () => {
  const { t } = useTranslation();
  const { updateBuySidePreviewMember, buySidePreviewMember } = useContext(
    DataRoomDocumentsContext,
  );

  return (
    <div
      className={classNames('documents-view-as-banner', {
        visible: !!buySidePreviewMember,
      })}
    >
      <p>
        {t('viewingAccessWarning', {
          name: buySidePreviewMember?.fullName || buySidePreviewMember?.email,
        })}
      </p>

      <Button
        variant="outline"
        onClick={() => updateBuySidePreviewMember(null)}
      >
        <XcircleIcon />
        {t('stop')}
      </Button>
    </div>
  );
};

export default DocumentsViewAsBanner;
